export const API_ENDPOINTS = {
    SOLDOUT_PRODUCTS: '/apps/store/api/v1.1/soldout-products',
    FILTERED_DATA: ({ publishedCatalogId, catalogType, customerId }) =>
        `/apps/store/rest/filters/catalog/${publishedCatalogId}/${catalogType}/customer/${customerId}`,
    NAMELIST_CUSTOMER: ({ customerNumber }) =>
        `/catalog/v1.1/customers/${customerNumber}/namelist-customer`,
    NAMELIST_VERIFICATION: ({ customerNumber, consumerId }) =>
        `/catalog/v1.1/customers/${customerNumber}/namelist-verification/${consumerId}`,
}
